import { render } from "./CustomerApplications.vue?vue&type=template&id=1afd8ad4&scoped=true"
import script from "./CustomerApplications.vue?vue&type=script&lang=js"
export * from "./CustomerApplications.vue?vue&type=script&lang=js"

import "./CustomerApplications.vue?vue&type=style&index=0&id=1afd8ad4&scoped=true&lang=css"
import "./CustomerApplications.vue?vue&type=style&index=1&id=1afd8ad4&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1afd8ad4"]])

export default __exports__